jQuery(function ($) {
  $(function () {
    $(".faq__item .faq__q").click(function () {
      $(this).next(".faq__a").slideToggle();
      $(this).addclass("open");
    });
  });

  $(window).on("load", function () {
    var innerHeight = window.innerHeight;
    var newHeight = innerHeight - 86; // 90remを引く
    $(".js-main-vh").css("height", newHeight + "px");
  });
  let completed = false;
});

// 20240205アコーディオン
const accordion = document.querySelectorAll(".js-ac-toggle");
function acToggle() {
  const content = this.nextElementSibling;

  content.classList.toggle("is-open");

  const accordion = this;
  accordion.classList.toggle("is-open");
}

for (let i = 0; i < accordion.length; i++) {
  accordion[i].addEventListener("click", acToggle);
}
